@if (loading()) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
} @else {
	<app-setup-wizard-dynamic-table
		[enableEditButton]="enableEditButton()"
		[enableToggleDisableButton]="enableToggleDisableButton()"
		[enableRemoveButton]="enableRemoveButton()"
		[enableResetButton]="enableResetButton()"
		[selectedRow]="selectedRow()"
		[rows]="rows()"
		[pageSize]="pageSize()"
		[columns]="columns()"
		(onToggleDisable)="onToggleDisableClick($event)"
		(onRemove)="onRemoveClick($event)"
		(onReset)="onResetClick($event)"
		(onEdit)="onEditClick($event)"
	>
		<!-- Header templates (defines order/keys) -->
		<ng-template [appHeaderColumn]="CourseCsvKeys.ssoCourseId">
			{{ COURSE_CSV_LABELS[CourseCsvKeys.ssoCourseId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="CourseCsvKeys.defaultLangId">
			{{ COURSE_CSV_LABELS[CourseCsvKeys.defaultLangId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="CourseCsvKeys.displayOrder">
			{{ COURSE_CSV_LABELS[CourseCsvKeys.displayOrder] }}
		</ng-template>
		<ng-template [appHeaderColumn]="CourseCsvKeys.rubricCode">
			{{ COURSE_CSV_LABELS[CourseCsvKeys.rubricCode] }}
		</ng-template>
		<ng-template [appHeaderColumn]="CourseCsvKeys.productName">
			{{ COURSE_CSV_LABELS[CourseCsvKeys.productName] }}
		</ng-template>
		<ng-template [appHeaderColumn]="CourseCsvKeys.enName">
			{{ COURSE_CSV_LABELS[CourseCsvKeys.enName] }}
		</ng-template>
		<ng-template [appHeaderColumn]="CourseCsvKeys.active">
			{{ COURSE_CSV_LABELS[CourseCsvKeys.active] }}
		</ng-template>

		<ng-template appHeaderColumn="status">Status</ng-template>

		<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
		<ng-template [appRowColumn]="CourseCsvKeys.ssoCourseId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="CourseCsvKeys.ssoCourseId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="CourseCsvKeys.defaultLangId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="CourseCsvKeys.defaultLangId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="CourseCsvKeys.displayOrder" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="CourseCsvKeys.displayOrder"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="CourseCsvKeys.rubricCode" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="CourseCsvKeys.rubricCode"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="CourseCsvKeys.productName" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="CourseCsvKeys.productName"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="CourseCsvKeys.enName" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="CourseCsvKeys.enName"></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="CourseCsvKeys.active" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="CourseCsvKeys.active"></app-setup-wizard-before-after>
		</ng-template>

		<ng-template appRowColumn="status" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after-status [data]="row"></app-setup-wizard-before-after-status>
		</ng-template>
	</app-setup-wizard-dynamic-table>
}
